// assets
import { IconBriefcase, IconChecklist, IconFileText, IconLifebuoy, IconSettingsAutomation, IconSettingsCog } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - OPERATIONS (P4-2) ||============================== //

const operations: NavItemType = {
  id: 'operations',
  title: 'operations', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconSettingsCog,
  type: 'group',
  requiredModule: 'operations',
  children: [
    {
      id: 'operations-documents',
      title: 'operations-documents',
      icon: IconFileText,
      type: 'item',
      url: '/operations/documents',
      module: 'operations.documents'
    },
    {
      id: 'operations-tickets',
      title: 'operations-tickets',
      icon: IconLifebuoy,
      type: 'item',
      url: '/operations/tickets',
      module: 'operations.tickets'
    },
    {
      id: 'operations-tasks',
      title: 'operations-tasks',
      icon: IconChecklist,
      type: 'item',
      url: '/operations/tasks',
      module: 'operations.tasks'
    },
    {
      id: 'operations-jobs',
      title: 'operations-jobs',
      icon: IconBriefcase,
      type: 'item',
      url: '/operations/jobs',
      module: 'operations.jobs'
    },
    {
      // ⚠ `permission:`, not `module:` — the module gate means "any jobs permission", but the job-type editor
      // is configure-only (D3: the developer-admin wires commands); everyone else would land on a 403.
      id: 'operations-job-types',
      title: 'operations-job-types',
      icon: IconSettingsAutomation,
      type: 'item',
      url: '/operations/job-types',
      permission: 'operations.jobs.configure'
    }
  ]
};

export default operations;
